<template>
  <div class="dragonIndex">
    <!-- 轮播图 -->
    <div class="banner">
      <Carousel radius-dot autoplay :autoplay-speed="5000" loop>
        <CarouselItem>
          <div>
            <img class="bannerImg" src="/img/dragonStar/banner5.jpg" alt="">
          </div>
        </CarouselItem>
        <CarouselItem>
          <div>
            <img class="bannerImg" src="/img/dragonStar/banner.jpg" alt="">
          </div>
        </CarouselItem>
        <CarouselItem>
          <div>
            <img class="bannerImg" src="/img/dragonStar/banner3.jpg" alt="">
          </div>
        </CarouselItem>
        <!-- <CarouselItem>
          <div>
            <img src="" alt="">
          </div>
        </CarouselItem>
        <CarouselItem>
          <div>
            <img src="" alt="">
          </div>
        </CarouselItem> -->
      </Carousel>
    </div>
    <!-- 奖项简介 -->
    <Row class="halfCircle" type="flex" align="middle">
      <Col :lg="{span: 9}" :sm="{span:24}">
        <div class="textWidth">
          <p class="size16">奖项简介</p>
          <p class="boldTitle">龙腾之星是什么？</p>
          <p>龙腾之星·第二届（2020）全球大学生绿色设计大赛以“绿色·共生”为主题。通过树立“自主创新”和“原始创新”理念，挖掘大学生的创新潜能，培养大学生的创新意识，促进国际高校间创新设计与创业团队的交流互动。发掘未来创新设计人才，在创新和创造中提高工作能力与设计素养，在投身经济社会发展的大进程中贡献聪明才智。</p>
          <Button shape="circle" class="moreBtn" to="/dragon_star/about">了解更多</Button>
        </div>
      </Col>
      <Col :lg="{span: 15}" :sm="{span:24}">
        <img class="imgWidth" src="/img/dragonStar/1.jpg" alt="">
      </Col>
    </Row>
    <!-- 奖项设置、参赛方式 -->
    <div class="awardSetting">
      <div class="awardRow">
        <Row type="flex" align="bottom" :gutter="50">
          <Col :lg="{span: 6, push: 18}" :sm="{span:12, push: 12}">
            <p class="size16">奖项设置</p>
            <p class="boldTitle">奖项分类&奖项设置</p>
            <p>各个奖项分类分别设置：</p>
            <p>全场大奖 1名 ；一等奖 5名；二等奖 15名；三等奖 20名</p>
            <p>以上奖项将获得奖金、奖章、定制奖牌及获奖证书</p>
            <p>另设置优秀奖、优秀指导教师奖、优秀组织奖等多种奖项</p>
            <Button shape="circle" class="moreBtn awardBtn" to="/dragon_star/award_setting">奖项详情</Button>
          </Col>
          <Col :lg="{span: 6, pull: 6}" :sm="{span:12, pull: 12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/dragonStar/2.jpg" alt="">
              <div class="itemText">绿色出行设计</div>
            </div>
          </Col>
          <Col :lg="{span: 6, pull: 6}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/dragonStar/3.jpg" alt="">
              <div class="itemText">绿色能源类</div>
            </div>
          </Col>
          <Col :lg="{span: 6, pull: 6}" :sm="{span:12}">
            <div class="settingWrap">
              <img class="itemImg" src="/img/dragonStar/4.jpg" alt="">
              <div class="itemText">绿色人居类</div>
            </div>
          </Col>
        </Row>  
      </div>
      <Row :gutter="50">
        <Col :lg="{span: 6}" :sm="{span:12}">
          <div class="settingWrap">
            <img class="itemImg" src="/img/dragonStar/5.jpg" alt="">
            <div class="itemText">绿色包装类</div>
          </div>
        </Col>
        <Col :lg="{span: 6}" :sm="{span:12}">
          <div class="settingWrap">
            <img class="itemImg" src="/img/dragonStar/6.jpg" alt="">
            <div class="itemText twoLine">
              <p>特殊群体</p>
              <p>绿色生活方式类</p>
            </div>
          </div>
        </Col>
        <Col :lg="{span: 6}" :sm="{span:12}">
          <div class="settingWrap">
            <img class="itemImg" src="/img/dragonStar/7.jpg" alt="">
            <div class="itemText twoLine">
              <p>绿色视觉传达设计</p>
              <p>（除包装）类</p>
            </div>
          </div>
        </Col>
        <Col :lg="{span: 6}" :sm="{span:12}">
          <div class="settingWrap">
            <img class="itemImg" src="/img/dragonStar/8.jpg" alt="">
            <div class="itemText twoLine">
              <p>企业参与</p>
              <p>特别定制类</p>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col :lg="{span: 22, offset:2}">
          <p class="size16 pdTop">参赛方式</p>
          <p class="boldTitle">参赛规则&大赛时间表</p>
        </Col>
      </Row>
      <Row class="wayWrap">
        <Col :lg="{span: 6, offset:2}" :sm="{span:24}">
          <p class="paragraph">大赛面向全球开展绿色设计的院校、研究机构、以及热衷于绿色设计和可持续发展研究的全日制在校大学生、研究生。</p>
          <p class="paragraph">参赛由高校推荐（个人或小组形式参赛）</p>
          <Button shape="circle" class="moreBtn signBtn" @click="showNote">立刻报名</Button>
        </Col>
        <Col :lg="{span: 16}" :sm="{span:24}">
          <img class="imgWidth" src="/img/dragonStar/9.jpg" alt="">
        </Col>
      </Row>
    </div>
    <!-- 媒体机构 -->
    <div class="center mediaWrap">
      <p class="size16">媒体&机构</p>
      <p class="boldTitle smBtm">绿色公益合作伙伴</p>
      <p class="boldTitle greenTitle">主办</p>
      <div>
        <img class="mediaImg" src="/img/dragonStar/10.jpg" alt="">
      </div>
      <p class="boldTitle greenTitle">指导单位</p>
      <div>
        <img class="mediaImg" src="/img/dragonStar/21.jpg" alt="">
      </div>
      <p class="boldTitle greenTitle">协办</p>
      <div>
        <img class="mediaImg" src="/img/dragonStar/11.jpg" alt="">
      </div>
      <p class="boldTitle greenTitle">支持单位</p>
      <div>
        <img class="mediaImg" src="/img/dragonStar/20.jpg" alt="">
      </div>
      <p class="boldTitle greenTitle">绿色公益合作伙伴</p>
      <div>
        <img class="mediaImg" src="/img/dragonStar/12.jpg" alt="">
      </div>
      <Button shape="circle" class="moreBtn mediaBtn" to="/dragon_star/about">了解更多</Button>
    </div>
    <!-- 立即报名 -->
    <div class="signWrap">
      <div><img class="greenImg" src="/img/dragonStar/1.png" alt=""></div>
      <div><Button class="signUpBtn" shape="circle" @click="showNote">立刻报名</Button></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showNote() {
      this.$parent.toSignUp();
    }
  }
};
</script>

<style lang="scss" scoped>
.dragonIndex {
  color: #808080;

  .banner {
    padding: 0 15px;
    font-size: 0;

    .bannerImg {
      width: 100%;
    }
  }
  .size16 {
    color: #4c4c4c;
    font-size: 16px;
  }
  .pdTop {
    padding-top: 20px;
  }
  .boldTitle {
    color: #4c4c4c;
    font-size: 20px;
    font-weight: 600;
    padding: 15px 0 40px;
  }
  .greenTitle {
    color: #346c4d;
    padding-bottom: 20px;
  }
  .moreBtn {
    background: #0f63af;
    border-color: #0f63af;
    color: #ffffff;
    box-shadow: 0 2px 5px 2px rgba($color: #0f63af, $alpha: 0.3);
    margin-top: 30px;
  }
  .imgWidth {
    width: 80%;
    margin-left: 20%;
    line-height: 0;
  }
  .halfCircle {
    background: url(/img/dragonStar/halfCircle.jpg) no-repeat top center;
    background-size: 40%;
    padding: 80px 0 60px 80px;
  }
  .awardSetting {
    position: relative;
    padding: 50px 80px;
    background: #f8f8fa;

    .awardRow {
      margin-left: -80px;
      padding-right: 80px;
    }
    .awardBtn {
      margin-bottom: 50px;
      background: #59c0ca;
      border-color: #59c0ca;
      box-shadow: 0 2px 5px 2px rgba($color: #59c0ca, $alpha: 0.3);
    }
    .signBtn {
      margin-bottom: 50px;
      background: #009e40;
      border-color: #009e40;
      box-shadow: 0 2px 5px 2px rgba($color: #009e40, $alpha: 0.3);
    }
    .settingWrap {
      position: relative;
      font-size: 0;
      margin-bottom: 50px;

      .itemImg {
        width: 100%;
      }
      .itemText {
        font-size: 14px;
        position: absolute;
        right: 0;
        bottom: 0;
        background: #ffffff;
        height: 50px;
        text-align: center;
        color: #4c4c4c;
        line-height: 50px;
        width: 50%;
        min-width: 130px;
      }
      .twoLine {
        line-height: 1.2em;
        padding-top: 9px;
      }
    }
    .wayWrap {
      margin-right: -80px;
    }
  }
  .mediaWrap {
    padding: 50px 0;

    .smBtm {
      padding-bottom: 10px;
    }
    .mediaImg {
      width: 700px;
      max-width: 100%;
      padding-bottom: 15px;
    }
    .mediaBtn {
      background: #75bb2a;
      border-color: #75bb2a;
      box-shadow: 0 2px 5px 2px rgba($color: #75bb2a, $alpha: 0.3);
    }
  }
  .signWrap {
    background: url(/img/dragonStar/13.jpg) no-repeat;
    background-size: cover;
    padding: 80px 0;
    margin-bottom: 50px;
    text-align: center;

    .greenImg {
      width: 30%;
      max-width: 600px;
    }
    .signUpBtn {
      background: linear-gradient(to right, #0ba83b, #75bb2a);
      color: #ffffff;
      border-color: #75bb2a;
      box-shadow: 0 2px 5px 2px rgba($color: #47b135, $alpha: 0.3);
      margin-top: 40px;
      // padding: 3px 60px;
      // height: auto;
    }
  }
}
@media (max-width: 992px) {
  .dragonIndex {
    overflow-x: hidden;

    .halfCircle {
      padding-left: 15px;
      padding-right: 15px;

      .textWidth {
        width: 80%;
        padding-bottom: 50px;
      }
    }
    .awardSetting {
      padding-left: 15px;
      padding-right: 15px;

      .awardRow {
        margin: 0;
        padding: 0;
      }
      .wayWrap {
        margin-right: -15px;

        .paragraph {
          padding-right: 15px;
        }
      }
    }
    .signWrap {
      background-image: url(/img/dragonStar/14.jpg);

      .greenImg {
        width: 50%;
      }
    }
  }
}
</style>